// extracted by mini-css-extract-plugin
export var bg = "style-module--bg--0c25d";
export var cases = "style-module--cases--c6f3e";
export var content = "style-module--content--75800";
export var header = "style-module--header--0be48";
export var modal = "style-module--modal--351b9";
export var vid = "style-module--vid--d48fd";